import React, { ReactElement } from 'react';
import { IQuestionIconProps } from './types';
import { SCSvgPath, SCSvgRoot, SCSvgWrapper } from './styles';

const QuestionIcon = ({ iconState, disabled }: IQuestionIconProps): ReactElement => {
    return (
        <SCSvgWrapper
            data-testid={'question_icon'}
            aria-disabled={disabled ? 'true' : 'false'}
            role="img"
            aria-label="Question icon"
        >
            <SCSvgRoot
                aria-labelledby="Question icon"
                role="group"
                width="100%"
                height="100%"
                viewBox="0 0 25 25"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
            >
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'QuestionIconActive' : 'QuestionIconInactive'}
                    disabled={disabled}
                    d="M25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5ZM8.58802 9.42612H9.87628C10.092 9.42612 10.2636 9.2502 10.2925 9.03642C10.4315 8.01122 11.1352 7.26395 12.3894 7.26395C13.4606 7.26395 14.4425 7.79953 14.4425 9.0889C14.4425 10.0807 13.8573 10.537 12.9349 11.2312C11.8836 11.9949 11.0504 12.8876 11.11 14.3356L11.1146 14.6744C11.1175 14.888 11.2915 15.0597 11.5052 15.0597H12.7724C12.9881 15.0597 13.163 14.8848 13.163 14.669V14.5042C13.163 13.3835 13.5895 13.0562 14.74 12.1834C15.6922 11.4594 16.684 10.656 16.684 8.96988C16.684 6.60934 14.6904 5.46875 12.5084 5.46875C10.5286 5.46875 8.35881 6.39158 8.21111 9.04085C8.19925 9.2537 8.37485 9.42612 8.58802 9.42612ZM12.2208 19.4931C13.1729 19.4931 13.8275 18.8782 13.8275 18.045C13.8275 17.1822 13.1729 16.5771 12.2208 16.5771C11.3083 16.5771 10.6438 17.1822 10.6438 18.045C10.6438 18.8782 11.3083 19.4931 12.2208 19.4931Z"
                />
            </SCSvgRoot>
        </SCSvgWrapper>
    );
};

export { QuestionIcon };
